import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning',
    500050: 'isWarning'
};

const appActionMap = {
    pay: true,
    insure: true
};
interface Props {
    data: {
        productTitle: string;
        fromDate: string;
        toDate: string;
        serviceAddr: string;
        destination: string;
        count: number;
        patternToTake: string;
        _disable: boolean;
    };
}
class Ddr extends Component<Props> {
    public static formatData = (data: any) => {
        const newData = { ...data };
        // 订单状态
        newData._orderStatus = statusMap[newData.status];
        // icon
        newData.iconfont = '\uf27d';
        newData.iconColor = '#f48221';
        newData.title = newData.businessTitle ? newData.businessTitle : '惠玩当地';
        // 按钮信息
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        // 支付截止日期小黄条
        if (newData.payDeadline) {
            newData.deadlineNotice = `请于${newData.payDeadline}前完成支付`;
        }
        // 价格
        newData.currency = (newData.currency || '').trim();
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);

        return newData;
    };

    public render() {
        const {
            data: {
                productTitle,
                fromDate,
                toDate,
                serviceAddr,
                destination,
                count,
                patternToTake,
                _disable
            } = {}
        } = this.props;

        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                <Text style={styles.newOrderTitle} numberOfLines={2}>
                    {productTitle}
                </Text>
                {Boolean(fromDate && toDate) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {`使用时间  ${fromDate} 至 ${toDate}`}
                    </Text>
                )}
                {Boolean(serviceAddr) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {`服务地区  ${serviceAddr}`}
                    </Text>
                )}
                {Boolean(destination) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {`目的地  ${destination}`}
                    </Text>
                )}
                {Boolean(count) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {`购买份数  ${count}`}
                    </Text>
                )}
                {Boolean(patternToTake) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {`取件方式  ${patternToTake}`}
                    </Text>
                )}
            </View>
        );
    }
}

export default Ddr;
